import { createContext } from 'react';
import { useAuth } from "./Auth/AuthPage.jsx";

const UserContext = createContext();

export const useUserContext = () => {
    const { user, token } = useAuth();
    return {
        loggedIn: !!user && !!token,
        jti: user?.jti || null,
        rsvpMap: {}
    };
};

export default UserContext;